module.exports = __webpack_public_path__ + "img/top-protect.d8d9606f.jpg";